import { Box, Typography } from '@mui/material'

export default function TimeRail({ ticks, pxPerHour, height, compactText, row }) {
  return (
    <Box
      sx={{
        gridColumn: 1,
        gridRow: row,
        position: 'relative',
        height,
        borderRight: '1px solid',
        borderColor: 'divider',
      }}
    >
      {ticks.map(tick => (
        <Typography
          key={tick.minutes}
          variant="caption"
          sx={{
            position: 'absolute',
            top: tick.offsetHours * pxPerHour,
            right: 8,
            transform: 'translateY(-50%)',
            color: 'text.secondary',
            fontVariantNumeric: 'tabular-nums',
            fontSize: compactText ? 9 : undefined,
            whiteSpace: 'nowrap',
          }}
        >
          {tick.label}
        </Typography>
      ))}
    </Box>
  )
}
